(function() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const content = drawer.querySelector('[data-cart-content]');
  const totalEl = drawer.querySelector('[data-cart-total]');
  const countEls = document.querySelectorAll('.header__cart-badge');
  const itemsContainer = drawer.querySelector('.cart-drawer__items');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCartUI(cart) {
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (totalEl) {
      totalEl.textContent = formatMoney(cart.total_price);
    }
  }

  function formatMoney(cents) {
    const format = window.theme.moneyFormat || "${{amount}}";
    let value = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', value).replace('{{amount_no_decimals}}', (cents / 100).toFixed(0));
  }

  function refreshDrawer() {
    fetch(window.location.pathname + '?sections=cart-drawer')

    fetch(window.routes.cart_url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('[data-cart-content]');
        const newFooter = doc.querySelector('.cart-drawer__footer');

        if (newContent && content) {
          content.innerHTML = newContent.innerHTML;
        }

        const oldFooter = drawer.querySelector('.cart-drawer__footer');
        const newFooterEl = doc.querySelector('.cart-drawer__footer');

        // Keep whatever the customer typed in the note field (and its open state)
        const oldNote = oldFooter ? oldFooter.querySelector('[data-cart-note]') : null;
        const oldNoteDetails = oldFooter ? oldFooter.querySelector('.cart-drawer__note') : null;
        if (oldNote && newFooterEl) {
          const newNote = newFooterEl.querySelector('[data-cart-note]');
          const newNoteDetails = newFooterEl.querySelector('.cart-drawer__note');
          if (newNote) newNote.value = oldNote.value;
          if (newNoteDetails && oldNoteDetails) newNoteDetails.open = oldNoteDetails.open || oldNote.value.trim() !== '';
        }

        if (oldFooter && newFooterEl) {
          oldFooter.replaceWith(newFooterEl);
        } else if (!oldFooter && newFooterEl) {
          content.insertAdjacentElement('afterend', newFooterEl);
        } else if (oldFooter && !newFooterEl) {
            oldFooter.remove();
        }

        drawer.setAttribute('aria-hidden', 'false');
        addDrawerListeners();
      });
  }

  function addDrawerListeners() {
    drawer.querySelectorAll('[data-remove-item]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const item = this.closest('.cart-drawer__item');
        const key = item.dataset.lineItemKey;
        updateItem(key, 0);
      });
    });

    drawer.querySelectorAll('.cart-drawer__qty-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.parentElement.querySelector('input');
        const action = this.dataset.action;
        let qty = parseInt(input.value);
        const item = this.closest('.cart-drawer__item');
        const key = item.dataset.lineItemKey;

        if (action === 'increase') qty++;
        if (action === 'decrease') qty--;

        if (qty < 0) qty = 0;
        updateItem(key, qty);
      });
    });
  }

  function updateItem(key, qty) {

    const body = JSON.stringify({
      updates: {
        [key]: qty
      }
    });

    fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(res => res.json())
    .then(cart => {
      updateCartUI(cart);
      refreshDrawer();
    })
    .catch(err => console.error(err));
  }

  document.querySelectorAll('a[href="' + window.routes.cart_url + '"]').forEach(link => {
    link.addEventListener('click', function(e) {
      if (this.getAttribute('href') !== window.routes.cart_url) return;
      e.preventDefault();
      openDrawer();
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(el => {
    el.addEventListener('click', closeDrawer);
  });

  addDrawerListeners();

  window.openCartDrawer = openDrawer;
  window.refreshCartDrawer = refreshDrawer;

})();
